import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#07091a]/95 backdrop-blur-md border-b border-white/5 shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/32bb7955-927e-461e-9db0-09455eaedac3.png"
            alt="Silo Intelligence Logo"
            className="h-[100px] w-[100px] object-contain"
          />

        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {['problem', 'solution', 'features', 'industries'].map((id) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="text-white/70 hover:text-white text-sm font-medium transition-colors capitalize cursor-pointer whitespace-nowrap"
            >
              {id === 'features' ? 'Features' : id.charAt(0).toUpperCase() + id.slice(1)}
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => scrollTo('cta')}
            className="bg-gradient-to-r from-violet-600 to-indigo-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
          >
            Book a Strategy Call
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white/80 hover:text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#07091a]/98 backdrop-blur-md border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          {['problem', 'solution', 'features', 'industries'].map((id) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="text-white/70 hover:text-white text-sm font-medium text-left capitalize cursor-pointer"
            >
              {id === 'features' ? 'Features' : id.charAt(0).toUpperCase() + id.slice(1)}
            </button>
          ))}
          <button
            onClick={() => scrollTo('cta')}
            className="bg-gradient-to-r from-violet-600 to-indigo-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            Book a Strategy Call
          </button>
        </div>
      )}
    </nav>
  );
}
